import React, { useEffect, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Sidebar from '../components/Sidebar';
import { useAuth } from '../context/AuthContext';
import arrowIcon from '../assets/arrow-icon.png';
import arrowIcon2 from '../assets/Arrow4.png';
import likeIcon from '../assets/Like_icon.png';
import unLikeIconImage from '../assets/unLike_icon.png';
import frame147 from '../assets/frame147.png';
import priorityIcon from '../assets/priority-icon.png';
import solanaIcon from '../assets/solana-icon.png';
import transferIcon from '../assets/transfer-icon.png';
// Коллекция 1 - изображения
import col1_img1 from '../assets/col1_img1.jpg';
import col1_img2 from '../assets/col1_img2.jpg';
import col1_img3 from '../assets/col1_img3.jpg';
import col1_img4 from '../assets/col1_img4.jpg';
import col1_img5 from '../assets/col1_img5.jpg';
import col1_img6 from '../assets/col1_img6.jpg';
import col1_img7 from '../assets/col1_img7.jpg';
import col1_img8 from '../assets/col1_img8.jpg';
// Коллекция 2 - изображения
import col2_img1 from '../assets/col2_img1.jpg';
import col2_img2 from '../assets/col2_img2.jpg';
import col2_img3 from '../assets/col2_img3.jpg';
import col2_img4 from '../assets/col2_img4.jpg';
import col2_img5 from '../assets/col2_img5.jpg';
import col2_img6 from '../assets/col2_img6.jpg';
import col2_img7 from '../assets/col2_img7.jpg';
import col2_img8 from '../assets/col2_img8.jpg';
import col2_img9 from '../assets/col2_img9.jpg';
// Коллекция 3 - изображения
import col3_img1 from '../assets/col3_img1.jpg';
import col3_img2 from '../assets/col3_img2.jpg';
import col3_img3 from '../assets/col3_img3.jpg';
import col3_img4 from '../assets/col3_img4.jpg';
import col3_img5 from '../assets/col3_img5.jpg';
import col3_img6 from '../assets/col3_img6.jpg';
// Коллекция 4 - изображения
import col4_img1 from '../assets/col4_img1.jpg';
import col4_img2 from '../assets/col4_img2.jpg';
import col4_img3 from '../assets/col4_img3.jpg';
import col4_img4 from '../assets/col4_img4.jpg';
import col4_img5 from '../assets/col4_img5.jpg';
import col4_img6 from '../assets/col4_img6.jpg';
import col4_img7 from '../assets/col4_img7.jpg';
import col4_img8 from '../assets/col4_img8.jpg';
// Коллекция 5 - изображения
import col5_img1 from '../assets/col5_img1.jpg';
import col5_img2 from '../assets/col5_img2.jpg';
import col5_img3 from '../assets/col5_img3.jpg';
import col5_img4 from '../assets/col5_img4.jpg';
import col5_img5 from '../assets/col5_img5.jpg';
// Коллекция 6 - изображения
import col6_img1 from '../assets/col6_img1.jpg';
import col6_img2 from '../assets/col6_img2.jpg';
import col6_img3 from '../assets/col6_img3.jpg';
import col6_img4 from '../assets/col6_img4.jpg';
import col6_img5 from '../assets/col6_img5.jpg';
import col6_img6 from '../assets/col6_img6.jpg';
import nftPresentationBg from '../assets/NFT_presentation.png';

export default function NFTPurchasePage() {
  const { slug } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const nftIndex = parseInt(searchParams.get('nft') || '0');

  const { user, isAuthenticated, addToFavorites, removeFromFavorites } = useAuth();

  // Состояние лайка для текущего NFT
  const [isLiked, setIsLiked] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);
  const [collectionData, setCollectionData] = useState(null);

  // Функция для загрузки данных коллекции из БД
  const fetchCollectionData = async () => {
    try {
      const response = await fetch(`/api/collections/${slug}`);
      if (response.ok) {
        const data = await response.json();
        setCollectionData(data.collection);
      } else {
        console.error('Failed to fetch collection data');
      }
    } catch (error) {
      console.error('Error fetching collection data:', error);
    }
  };

  // Загрузка данных коллекции из БД
  useEffect(() => {
    if (slug) {
      fetchCollectionData();
    }
  }, [slug]);

  // Синхронизируем isLiked с данными пользователя (favorites)
  useEffect(() => {
    if (!user || !Array.isArray(user.favorites)) {
      setIsLiked(false);
      return;
    }
    const liked = user.favorites.some(
      (fav) =>
        fav.slug === slug &&
        typeof fav.nftIndex === 'number' &&
        fav.nftIndex === nftIndex
    );
    setIsLiked(liked);
  }, [user, slug, nftIndex]);

  const handleLikeToggle = async () => {
    if (!isAuthenticated) {
      console.warn('Необходимо войти, чтобы добавлять в избранное');
      // Здесь при желании можно открыть модалку авторизации
      return;
    }

    const currentlyLiked = isLiked;
    
    // Запускаем анимацию только при добавлении лайка
    if (!currentlyLiked) {
      setIsAnimating(true);
      setTimeout(() => setIsAnimating(false), 600); // Длительность анимации
    }
    
    setIsLiked(!currentlyLiked);

    if (!currentlyLiked) {
      const result = await addToFavorites(slug, nftIndex);
      if (!result.success) {
        console.error('Ошибка добавления в favorites:', result.message);
        setIsLiked(currentlyLiked);
        setIsAnimating(false);
      } else {
        // Обновляем данные коллекции, чтобы получить актуальное значение favorites
        await fetchCollectionData();
      }
    } else {
      const result = await removeFromFavorites(slug, nftIndex);
      if (!result.success) {
        console.error('Ошибка удаления из favorites:', result.message);
        setIsLiked(currentlyLiked);
      } else {
        // Обновляем данные коллекции, чтобы получить актуальное значение favorites
        await fetchCollectionData();
      }
    }
  };

  // Данные коллекций с изображениями
  const collectionsData = {
    'cyberpank': {
      images: [col1_img1, col1_img2, col1_img3, col1_img4, col1_img5, col1_img6, col1_img7, col1_img8],
      title: 'Cyberpank'
    },
    'myth-cats': {
      images: [col2_img1, col2_img2, col2_img3, col2_img4, col2_img5, col2_img6, col2_img7, col2_img8, col2_img9],
      title: 'MythCats'
    },
    'future-illusion': {
      images: [col3_img1, col3_img2, col3_img3, col3_img4, col3_img5, col3_img6],
      title: 'Future Illusion'
    },
    'spirits-above': {
      images: [col4_img1, col4_img2, col4_img3, col4_img4, col4_img5, col4_img6, col4_img7, col4_img8],
      title: 'Spirits Above'
    },
    'wonder': {
      images: [col5_img1, col5_img2, col5_img3, col5_img4, col5_img5],
      title: 'Wonder'
    },
    'energy-near-you': {
      images: [col6_img1, col6_img2, col6_img3, col6_img4, col6_img5, col6_img6],
      title: 'Energy Near You'
    }
  };

  // Определяем текущую коллекцию по slug
  const currentCollection = collectionsData[slug] || collectionsData['cyberpank'];
  const nftImages = currentCollection.images;
  const selectedNFTImage = nftImages[nftIndex] || nftImages[0];

  // Компонент карточки статуса
  const StatusCard = ({ type = 'status' }) => {
    const isTransfer = type === 'transfer';
    const cardHeight = isTransfer ? '220px' : '190px';
    const bottomSectionTop = isTransfer ? '174px' : '144px';
    const topIcon = isTransfer ? transferIcon : priorityIcon;
    const topText = isTransfer ? 'Transfer' : 'On Sale';
    const priceTop = isTransfer ? '76px' : '66px';
    const bojarTop = isTransfer ? '121px' : '111px';
    const arrowIcon1Top = isTransfer ? '67px' : '57px';
    const arrowIcon2Top = isTransfer ? '95px' : '85px';
    const solanaIconTop = isTransfer ? '78px' : '68px';
    const text11Top = isTransfer ? '77px' : '67px';
    const textDashesTop = isTransfer ? '121px' : '111px';

    return (
    <div
      style={{
        position: 'relative',
        width: '240px',
        height: cardHeight,
        backgroundColor: 'rgba(82, 0, 0, 0.11)',
        border: '1px solid #790E0E',
        borderRadius: '4px'
      }}
    >
      {/* Top Section - 240x49 */}
      <div
        style={{
          position: 'absolute',
          left: '0px',
          top: '0px',
          width: '238px',
          height: '49px',
          backgroundColor: '#000000',
          borderBottom: '1px solid #701010'
        }}
      >
        {/* Icon - 30x30 at 19, 8 */}
        <div
          style={{
            position: 'absolute',
            left: '19px',
            top: '8px',
            width: '30px',
            height: '30px'
          }}
        >
          <img
            src={topIcon}
            alt={isTransfer ? "Transfer" : "Priority"}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain'
            }}
          />
        </div>
        
        {/* Text - at 151, 14 */}
        <div
          style={{
            position: 'absolute',
            left: '151px',
            top: '14px',
            fontFamily: 'Megrim',
            fontWeight: 400,
            fontSize: '18px',
            color: 'rgba(255, 255, 255, 0.9)'
          }}
        >
          {topText}
        </div>
      </div>

      {/* Bottom Section - 240x46 */}
      <div
        style={{
          position: 'absolute',
          left: '0px',
          top: bottomSectionTop,
          width: '238px',
          height: '44px',
          backgroundColor: '#000000',
          borderTop: '1px solid #790E0E'
        }}
      >
        {/* Time Text - at 24, 12 */}
        <div
          style={{
            position: 'absolute',
            left: '24px',
            top: '12px',
            fontFamily: 'Megrim',
            fontWeight: 500,
            fontSize: '18px',
            color: '#FFFFFF'
          }}
        >
          Time
        </div>
        
        {/* Date Text - at 164, 15 */}
        <div
          style={{
            position: 'absolute',
            left: '164px',
            top: '15px',
            fontFamily: 'Keania One',
            fontWeight: 400,
            fontSize: '12px',
            color: '#FFFFFF'
          }}
        >
          11.04.25
        </div>
      </div>

      {/* Price Text - at 43, 21 (relative to parent 240x190) */}
      <div
        style={{
          position: 'absolute',
          left: '25px',
          top: priceTop,
          fontFamily: 'Megrim',
          fontWeight: 500,
          fontSize: '18px',
          color: '#FFFFFF'
        }}
      >
        Price
      </div>

      {/* @Bojar Text - at 20, 111 */}
      <div
        style={{
          position: 'absolute',
          left: '20px',
          top: bojarTop,
          fontFamily: 'Megrim',
          fontWeight: 500,
          fontSize: '16px',
          color: '#FFFFFF'
        }}
      >
        @Bojar
      </div>

      {/* Arrow Icon - 50x50 at 97, 77 */}
      <div
        style={{
          position: 'absolute',
          left: '97px',
          top: arrowIcon1Top,
          width: '50px',
          height: '50px'
        }}
      >
        <img
          src={arrowIcon}
          alt="Arrow"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'contain'
          }}
        />
      </div>

      {/* Arrow Icon - 70x70 at 87, 121 */}
      <div
        style={{
          position: 'absolute',
          left: '87px',
          top: arrowIcon2Top,
          width: '70px',
          height: '70px'
        }}
      >
        <img
          src={arrowIcon}
          alt="Arrow"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'contain'
          }}
        />
      </div>

      {/* Solana Icon - 18x18 at 176, 68 */}
      <div
        style={{
          position: 'absolute',
          left: '176px',
          top: solanaIconTop,
          width: '18px',
          height: '18px'
        }}
      >
        <img
          src={solanaIcon}
          alt="Solana"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'contain'
          }}
        />
      </div>

      {/* Text "11" - at 199, 67 */}
      <div
        style={{
          position: 'absolute',
          left: '199px',
          top: text11Top,
          fontFamily: 'Keania One',
          fontWeight: 400,
          fontSize: '16px',
          color: '#FFFFFF'
        }}
      >
        11
      </div>

      {/* Text "---" - at 186, 111 */}
      <div
        style={{
          position: 'absolute',
          left: '186px',
          top: textDashesTop,
          fontFamily: 'Keania One',
          fontWeight: 400,
          fontSize: '16px',
          color: '#FFFFFF'
        }}
      >
        ---
      </div>
    </div>
    );
  };

  return (
    <div className="h-screen bg-[#1E1E1E] text-white main-font flex flex-col overflow-hidden">
      <Header />

      <div className="flex flex-1 overflow-hidden">
        <Sidebar activePage="collection" />

        {/* Main Content */}
        <main className="flex-1 bg-[#1E1E1E] flex flex-col overflow-hidden">
          {/* Scrollable Content Area */}
          <div className="flex-1 overflow-y-auto overflow-x-hidden">
            {/* First Section - 1677x640 */}
            <div 
              className="relative"
              style={{
                width: '1677px',
                height: '640px',
                margin: '0'
              }}
            >
              {/* First Subsection (Left) - 737x640 */}
              <div 
                className="absolute"
                style={{
                  left: '0px',
                  top: '0px',
                  width: '737px',
                  height: '640px',
                  backgroundColor: '#040404',
                  backgroundImage: `url(${nftPresentationBg})`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                  borderRight: '1px solid #790E0E'
                }}
              >
                {/* NFT Label - 112x31 */}
                <div 
                  className="absolute"
                  style={{
                    left: 0,
                    top: 0,
                    width: '112px',
                    height: '31px',
                    backgroundColor: '#000000',
                    borderBottomRightRadius: '8px',
                    zIndex: 2,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  <div 
                    style={{
                      fontFamily: 'Keania One',
                      fontWeight: 400,
                      fontSize: '18px',
                      color: '#FFFFFF'
                    }}
                  >
                    NFT
                  </div>
                </div>

                {/* NFT Image - 588x504 at coordinates 74, 85 */}
                <div 
                  style={{
                    position: 'absolute',
                    left: '74px',
                    top: '85px',
                    width: '588px',
                    height: '504px',
                    overflow: 'hidden',
                    border: '4px solid #8F0A0A'
                  }}
                >
                  <img 
                    src={selectedNFTImage}
                    alt={`NFT ${nftIndex + 1}`}
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover'
                    }}
                  />
                </div>
              </div>

              {/* Second Subsection (Right) - 940x640 */}
              <div 
                className="absolute"
                style={{
                  left: '737px',
                  top: '0px',
                  width: '940px',
                  height: '640px',
                  backgroundColor: 'rgba(0, 0, 0, 0.4)'
                }}
              >
                {/* Top Element - 940x60 */}
                <div 
                  style={{
                    position: 'absolute',
                    left: '0px',
                    top: '0px',
                    width: '940px',
                    height: '60px',
                    backgroundColor: 'transparent',
                    borderBottom: '1px solid #8F0A0A'
                  }}
                >
                  <div 
                    style={{
                      position: 'absolute',
                      left: '24px',
                      top: '15px',
                      fontFamily: 'Keania One',
                      fontWeight: 400,
                      fontSize: '18px',
                      color: 'rgba(255, 255, 255, 0.8)'
                    }}
                  >
                    {collectionData?.title || currentCollection.title || 'Law at the end of the day'}
                  </div>
                </div>

                {/* Block Container - 830x350 */}
                <div 
                  style={{
                    position: 'absolute',
                    left: '55px',
                    top: '90px',
                    width: '830px',
                    height: '350px',
                    backgroundColor: 'transparent',
                    border: '1px solid #8F0A0A'
                  }}
                >
                  {/* Title: NFT name from DB */}
                  <div 
                    style={{
                      position: 'absolute',
                      left: '24px',
                      top: '20px',
                      fontFamily: 'Keania One',
                      fontWeight: 400,
                      fontSize: '18px',
                      color: 'rgba(255, 255, 255, 0.8)'
                    }}
                  >
                    {collectionData?.nfts?.[nftIndex]?.nftname || 'Rain on the bridge'}
                  </div>

                  {/* Like Icon - 40x40 (toggle between unlike/like, синхронизировано с favorites) */}
                  <button
                    type="button"
                    onClick={handleLikeToggle}
                    style={{
                      position: 'absolute',
                      left: '750px',
                      top: '15px',
                      width: '40px',
                      height: '40px',
                      padding: 0,
                      border: 'none',
                      background: 'transparent',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                    aria-label={isLiked ? 'Remove from favorites' : 'Add to favorites'}
                  >
                    <img 
                      src={isLiked ? likeIcon : unLikeIconImage}
                      alt={isLiked ? 'Liked' : 'Not liked'}
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'contain',
                        transform: isAnimating ? 'scale(1.5)' : 'scale(1)',
                        transition: 'transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)'
                      }}
                    />
                  </button>

                  {/* 6 Blocks - metadata blocks */}
                  {[
                    { left: 55, top: 87, label: 'Creator', value: '@Adam' },
                    { left: 55, top: 164, label: 'Last Price', value: '7 Sol' },
                    { left: 315, top: 87, label: 'Followers', value: '11' },
                    { left: 315, top: 164, label: 'Favorites', value: String(collectionData?.stats?.favorites ?? 0) },
                    { left: 574, top: 87, label: 'Rating', value: '3.4' },
                    { left: 574, top: 164, label: 'Holder', value: '@Adam' }
                  ].map((block, index) => (
                    <div
                      key={index}
                      style={{
                        position: 'absolute',
                        left: `${block.left}px`,
                        top: `${block.top}px`,
                        width: '200px',
                        height: '60px',
                        border: '1px solid rgba(143, 10, 10, 0.8)',
                        display: 'flex',
                        overflow: 'hidden'
                      }}
                    >
                      {/* First half - 100x60, color #8F0A0A */}
                      <div 
                        style={{
                          width: '100px',
                          height: '60px',
                          backgroundColor: '#8F0A0A',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          fontFamily: 'Keania One',
                          fontWeight: 400,
                          fontSize: '18px',
                          color: 'rgba(255, 255, 255, 0.8)'
                        }}
                      >
                        {block.label}
                      </div>
                      {/* Second half - 100x60, color rgba(0, 0, 0, 0.4) */}
                      <div 
                        style={{
                          width: '100px',
                          height: '60px',
                          backgroundColor: 'rgba(0, 0, 0, 0.4)',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          fontFamily: 'Keania One',
                          fontWeight: 400,
                          fontSize: '18px',
                          color: 'rgba(255, 255, 255, 0.8)'
                        }}
                      >
                        {block.value}
                      </div>
                    </div>
                  ))}

                  {/* Divider Line - 733x4 */}
                  <div 
                    style={{
                      position: 'absolute',
                      left: '48px',
                      top: '250px',
                      width: '733px',
                      height: '4px',
                      backgroundColor: 'rgba(127, 11, 11, 0.6)'
                    }}
                  />

                  {/* First Element - Status/On Sale - 200x60 at 55, 270 */}
                  <div 
                    style={{
                      position: 'absolute',
                      left: '55px',
                      top: '270px',
                      width: '200px',
                      height: '60px',
                      display: 'flex',
                      overflow: 'hidden'
                    }}
                  >
                    {/* First half - 100x60, color #0A8F51 */}
                    <div 
                      style={{
                        width: '100px',
                        height: '60px',
                        backgroundColor: '#0A8F51',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontFamily: 'Keania One',
                        fontWeight: 400,
                        fontSize: '18px',
                        color: 'rgba(255, 255, 255, 0.8)'
                      }}
                    >
                      Status
                    </div>
                    {/* Second half - 100x60, color #0E0E0E, border rgba(10, 143, 81, 0.8) */}
                    <div 
                      style={{
                        width: '100px',
                        height: '60px',
                        backgroundColor: '#0E0E0E',
                        border: '1px solid rgba(10, 143, 81, 0.8)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontFamily: 'Keania One',
                        fontWeight: 400,
                        fontSize: '18px',
                        color: 'rgba(255, 255, 255, 0.8)'
                      }}
                    >
                      On Sale
                    </div>
                  </div>

                  {/* Second Element - Cost/11 sol - 200x60 at 315, 270 */}
                  <div 
                    style={{
                      position: 'absolute',
                      left: '315px',
                      top: '270px',
                      width: '200px',
                      height: '60px',
                      display: 'flex',
                      overflow: 'hidden'
                    }}
                  >
                    {/* First half - 100x60, color #00989B */}
                    <div 
                      style={{
                        width: '100px',
                        height: '60px',
                        backgroundColor: '#00989B',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontFamily: 'Keania One',
                        fontWeight: 400,
                        fontSize: '18px',
                        color: 'rgba(255, 255, 255, 0.8)'
                      }}
                    >
                      Cost
                    </div>
                    {/* Second half - 100x60, color #0E0E0E, border #038C8E */}
                    <div 
                      style={{
                        width: '100px',
                        height: '60px',
                        backgroundColor: '#0E0E0E',
                        border: '1px solid #038C8E',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontFamily: 'Keania One',
                        fontWeight: 400,
                        fontSize: '18px',
                        color: 'rgba(255, 255, 255, 0.8)'
                      }}
                    >
                      11 sol
                    </div>
                  </div>

                  {/* Arrow Icon - 77x1 at 559, 300 */}
                  <div 
                    style={{
                      position: 'absolute',
                      left: '559px',
                      top: '260px',
                      width: '77px',
                      height: '77px'
                    }}
                  >
                    <img 
                      src={arrowIcon2}
                      alt="Arrow"
                      style={{
                        width: '77px',
                        height: '77px',
                        objectFit: 'contain'
                      }}
                    />
                  </div>

                  {/* Buy Button - 100x60 at 674, 270 */}
                  <div 
                    style={{
                      position: 'absolute',
                      left: '674px',
                      top: '270px',
                      width: '100px',
                      height: '60px',
                      backgroundColor: '#66A9FF',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      cursor: 'pointer'
                    }}
                  >
                    <span 
                      style={{
                        fontFamily: 'Keania One',
                        fontWeight: 400,
                        fontSize: '19px',
                        color: '#FFFFFF'
                      }}
                    >
                      Buy
                    </span>
                  </div>
                </div>

                {/* Second Section - 942x140 - positioned under "Rain on the bridge" block */}
                <div 
                  style={{
                    position: 'absolute',
                    left: '0px',
                    bottom: '5px',
                    width: '942px',
                    height: '140px',
                    backgroundColor: 'transparent',
                    borderTop: '1px solid #830C0C'
                  }}
                >
                  {/* Background Image - frame147.png - 942x114 at bottom */}
                  <div 
                    style={{
                      position: 'absolute',
                      left: '0px',
                      bottom: '0px',
                      width: '942px',
                      height: '114px'
                    }}
                  >
                    <img 
                      src={frame147}
                      alt="Frame"
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover'
                      }}
                    />
                  </div>

                  {/* Collection Text */}
                  <div 
                    style={{
                      position: 'absolute',
                      left: '29px',
                      top: '5px',
                      fontFamily: 'Keania One',
                      fontWeight: 400,
                      fontSize: '12px',
                      color: '#FFFFFF',
                      zIndex: 1
                    }}
                  >
                    Collection
                  </div>

                  {/* Collection Images */}
                  <div 
                    style={{
                      position: 'absolute',
                      left: '27px',
                      top: '35px',
                      display: 'flex',
                      gap: '10px',
                      zIndex: 2
                    }}
                  >
                    {nftImages.map((image, index) => (
                      <div
                        key={index}
                        style={{
                          width: '140px',
                          height: '90px',
                          overflow: 'hidden',
                          cursor: 'pointer'
                        }}
                        onClick={() => {
                          // Navigate to this NFT
                          setSearchParams({ nft: index.toString() });
                        }}
                      >
                        <img 
                          src={image}
                          alt={`NFT ${index + 1}`}
                          style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover'
                          }}
                        />
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            {/* Status and Transaction Story Container */}
            <div 
              style={{
                display: 'flex',
                width: '100%'
              }}
            >
              {/* Status Section - 360x30 */}
              <div 
                style={{
                  width: '360px',
                  height: '30px',
                  backgroundColor: '#040404',
                  borderTop: '1px solid #830C0C',
                  borderBottom: '1px solid #830C0C',
                  borderRight: '1px solid #830C0C',
                  display: 'flex',
                  alignItems: 'center',
                  paddingLeft: '15px'
                }}
              >
                <span 
                  style={{
                    fontFamily: 'Keania One',
                    fontWeight: 400,
                    fontSize: '16px',
                    color: 'rgba(255, 255, 255, 0.8)'
                  }}
                >
                  Status
                </span>
              </div>

              {/* Transaction Story Section - 1321x30 */}
              <div 
                style={{
                  width: '1310px',
                  height: '30px',
                  backgroundColor: '#020202',
                  borderBottom: '1px solid #830C0C',
                  borderTop: '1px solid #830C0C',
                  display: 'flex',
                  alignItems: 'center',
                  paddingLeft: '15px'
                }}
              >
                <span 
                  style={{
                    fontFamily: 'Keania One',
                    fontWeight: 400,
                    fontSize: '16px',
                    color: 'rgba(255, 255, 255, 0.8)'
                  }}
                >
                  Transaction Story
                </span>
              </div>
            </div>

            {/* Content Sections Container */}
            <div 
              style={{
                display: 'flex',
                width: '100%'
              }}
            >
              {/* Content Section - 360x250 */}
              <div 
                style={{
                  position: 'relative',
                  left: '0px',
                  top: '0px',
                  width: '360px',
                  height: '250px',
                  backgroundColor: '#040404',
                  borderRight: '1px solid #830C0C',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                <StatusCard />
              </div>

              {/* Transaction Story Content Section - 1310x250 */}
              <div 
                style={{
                  width: '1310px',
                  height: '250px',
                  backgroundColor: 'transparent',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'flex-start',
                  paddingLeft: '20px',
                  gap: '20px',
                  overflowX: 'auto'
                }}
              >
                {[1, 2, 3, 4, 5].map((index) => (
                  <StatusCard key={index} type="transfer" />
                ))}
              </div>
            </div>
          </div>
          <Footer />
        </main>
      </div>
    </div>
  );
}

